function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

// Shopify editor
function editorShopifyEvent(t, e, i) {
  let n = !1;
  t.type.includes("shopify:section")
    ? e.hasAttribute("data-section-id") &&
      e.getAttribute("data-section-id") === t.detail.sectionId &&
      (n = !0)
    : t.type.includes("shopify:block") && t.target === e && (n = !0),
    n && i(t);
}

// Shopify Currency Symbol
const currencySymbol = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "Tk",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "₿",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  COU: "COU",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "лв",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$",
};
const shopCurrencySymbol = currencySymbol[Shopify.currency.active];

/* Get Sibling */
const getSiblings = function (elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

/* Slide Up */
const slideUp = (target, time) => {
  const duration = time ? time : 500;
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
/* Slide Down */
const slideDown = (target, time) => {
  let duration = time ? time : 500;
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

// Get window top offset
function TopOffset(el) {
  let rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class DataCountdown extends HTMLElement {
  constructor() {
    super();

    this.onCountDown();
  }

  onCountDown() {
    const CountDownElement = this.querySelector("[data-countdown]");

    const countDownItem = (value, label) => {
      return `<div class="countdown-item ${label}"><div class="countdown__inner"><span class="countdown__digit">${value}</span> <span class="countdown__labels">${label}</span></div></div>`;
    };
    const date = new Date(
        CountDownElement.getAttribute("data-countdown")
      ).getTime(),
      second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
    const countDownInterval = setInterval(function () {
      let currentTime = new Date().getTime(),
        timeDistance = date - currentTime,
        daysValue = Math.floor(timeDistance / day),
        hoursValue = Math.floor((timeDistance % day) / hour),
        minutesValue = Math.floor((timeDistance % hour) / minute),
        secondsValue = Math.floor((timeDistance % minute) / second);

      CountDownElement.innerHTML =
        countDownItem(daysValue, window.countdown.days) +
        countDownItem(hoursValue, window.countdown.Hours) +
        countDownItem(minutesValue, window.countdown.minutes) +
        countDownItem(secondsValue, window.countdown.second);

      if (timeDistance < 0) clearInterval(countDownInterval);
    }, 1000);
  }
}
customElements.define("countdown-timer", DataCountdown);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("[grid-recommendation]");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.querySelector("[grid-recommendation]").innerHTML =
              recommendations.innerHTML;
          }

          if (recommendations) {
            if (recommendations.innerHTML.trim().length === 0) {
              this.parentElement.classList.add("no-js-inline");
            } else {
              this.children[0].classList.remove("no-js-inline");
            }
          }

          if (html.querySelector(".product-grid-item")) {
            this.classList.add("product-recommendations--loaded");
          }

          if (this.dataset.intent == "complementary") {
            let complementaryProducts = new Swiper(
              this.querySelector(".complementory--slider"),
              {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                autoHeight: true,
                pagination: {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true,
                },
                navigation: {
                  nextEl: this.querySelector(".swiper-button-next"),
                  prevEl: this.querySelector(".swiper-button-prev"),
                },
              }
            );
            this.querySelector(
              ".complementary-slideshow--slider"
            ).classList.remove("no-js-inline");

            this.querySelector("details")
              ? (this.querySelector("details").open = true)
              : null;
          }

          if (this.dataset.intent == "related") {
            let autoplay = false,
              sliderAutoplay = this.dataset.autoplay,
              autoPlayValue = false,
              autoPlayTime = parseInt(this.dataset.autoplayTime),
              sliderContainer = true;
            if (sliderAutoplay == "true") {
              autoPlayValue = {
                delay: autoPlayTime,
              };
            }
            if (this.dataset.sliderEnable !== "true") {
              sliderContainer = false;
            }

            let relatedProducts = new Swiper(
              this.querySelector(".productSlider"),
              {
                loop: true,
                slidesPerView: parseInt(this.dataset.showMobile),
                spaceBetween: 30,
                autoplay: autoPlayValue,
                pagination: {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true,
                  type: "fraction",
                },
                navigation: {
                  nextEl: this.querySelector(".swiper-button-next"),
                  prevEl: this.querySelector(".swiper-button-prev"),
                },
                breakpoints: {
                  640: {
                    slidesPerView: parseInt(this.dataset.showMobile),
                  },
                  750: {
                    slidesPerView: parseInt(this.dataset.showMobile),
                  },
                  992: {
                    slidesPerView: parseInt(this.dataset.showExtraLarge),
                  },
                },
              }
            );

            if (sliderContainer && sliderAutoplay == "true") {
              this.querySelector(".productSlider").addEventListener(
                "mouseenter",
                (e) => {
                  relatedProducts.autoplay.stop();
                }
              );
              this.querySelector(".productSlider").addEventListener(
                "mouseleave",
                (e) => {
                  relatedProducts.autoplay.start();
                }
              );
            }

            // Slide thumbnail height
            const slideThumbHeight = () => {
              const proudctThumbnails = this.querySelector(
                ".productSlider"
              ).querySelectorAll(".card--client-height");
              if (proudctThumbnails.length > 0) {
                const productThumbnailHeight = proudctThumbnails[0];
                this.querySelector(
                  ".productSlider"
                ).parentElement.style.setProperty(
                  "--slider-navigation-top-offset",
                  `${productThumbnailHeight.clientHeight / 2}px`
                );
              }
            };
            slideThumbHeight();
            window.addEventListener("resize", () => {
              slideThumbHeight();
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);


var lastURL = document.referrer;
var currentURL = window.location.href;
localStorage.setItem('lastURL', lastURL);
localStorage.setItem('currentURL', currentURL);

var storedLastURL = localStorage.getItem('lastURL');
var lasturl_split = storedLastURL.split('?')[0];
console.log("lasturl_split",lasturl_split)
var storedCurrentURL = localStorage.getItem('currentURL');
var CurrentURL_split = storedLastURL.split('?')[0];
console.log("CurrentURL_split",CurrentURL_split)
console.log("Stored Last URL: " + storedLastURL);
console.log("Stored Current URL: " + storedCurrentURL);
if(lasturl_split == CurrentURL_split){
  localStorage.setItem('sortrefresh', 'True');
}
else{
  localStorage.setItem('sortrefresh', 'False');
}

// Desktop Submenu Toggle
var Store_menu = [];
let Parent_menu = document.querySelectorAll('.header__mega_menu--inner .header__mega_menu_li');
// console.log("Parent_menu", Parent_menu);
Store_menu.push(...Parent_menu);
// console.log("Store_menu", Store_menu);
Parent_menu.forEach((menuItem, index) => {
    // Add class based on index
    menuItem.classList.add(`parent_menu-${index}`);
});

Store_menu.forEach((menuItem, menuIndex) => {
  let subMenus = menuItem.querySelectorAll('.header__mega_sub_menu .header__mega_sub_menu_li');
  subMenus.forEach((subMenu, subMenuIndex) => {
      subMenu.classList.add(`sub_menu-${subMenuIndex}`);
      if (subMenuIndex < 4) {
          subMenu.style.display = 'block';
      } else {
          subMenu.style.display = 'none';
      }
  });

  if (subMenus.length > 4) {
    var div_desktop = document.createElement("div");
    div_desktop.classList.add("desktop_menu_toggle-btn_wrapper");
      let pTag = document.createElement('p');
      pTag.innerText = 'Show More';
      pTag.classList.add(`sub_menu_toggle-${menuIndex}`);
      pTag.classList.add(`menu_toggle-btn`)
      div_desktop.appendChild(pTag);
      let megaSubMenu = menuItem.querySelector('.header__mega_sub_menu');
      if (megaSubMenu) {
          megaSubMenu.appendChild(div_desktop);
      }
  }
});

var desktop_submenu_btn = document.querySelectorAll('.menu_toggle-btn');
desktop_submenu_btn.forEach(function(btn) {

  btn.addEventListener('click', function(event) {
    var clickedElementClass = event.currentTarget.className;
    console.log('Clicked element class:', clickedElementClass);
    if(clickedElementClass.includes('sub_menu_toggle-')){
      var classListArray = clickedElementClass.split(' ');
      var matchedClass = classListArray.find(function(cls) {
        return cls.startsWith('sub_menu_toggle-');
      });
      if (matchedClass) { 
        var splittedClass = matchedClass.split('-')[1];
        console.log('The clicked split', splittedClass);
        var get_parent_menu =document.querySelector(".parent_menu-"+splittedClass);
        var header__mega_sub_menu = get_parent_menu.querySelector(".header__mega_sub_menu");
        var header__mega_sub_menu_li = header__mega_sub_menu.querySelectorAll("li");
        if (event.currentTarget.innerHTML == 'Show Less') {
          console.log("The button text is  'Show More'");
          var change_innertext = document.querySelector(".sub_menu_toggle-"+splittedClass);
          change_innertext.innerHTML = 'Show More';
          header__mega_sub_menu_li.forEach(function(li, index) {
            if (index < 4) { 
                li.style.display = 'block';
            } else {
                li.style.display = 'none'; 
            }
        });
        } else {
          console.log("The button text is  'Hide All'");
          var change_innertext = document.querySelector(".sub_menu_toggle-"+splittedClass);
          change_innertext.innerHTML = 'Show Less';
          header__mega_sub_menu_li.forEach(function(li) {
            li.style.display = 'block';
        });

        }
        console.log("show element",get_parent_menu)
      } else {
        console.log('No class matching "sub_menu_toggle-" found');
      }
    }
});
});

// Mobile Submenu Toggle
var mobile_Store_menu = [];
let mob_Parent_menu = document.querySelectorAll('.offcanvas__menu_ul .offcanvas__menu_li');
mobile_Store_menu.push(...mob_Parent_menu);
mob_Parent_menu.forEach((menuItem, index) => {
    menuItem.classList.add(`mob_parent_menu-${index}`);
});

mobile_Store_menu.forEach((menuItem, menuIndex) => {
  let mob_subMenus = menuItem.querySelectorAll('.offcanvas__sub_menu .offcanvas__sub_menu_li');
  mob_subMenus.forEach((subMenu, mob_subMenuIndex) => {
    if (menuIndex !== 0) {
      subMenu.classList.add(`mob_sub_menu-${mob_subMenuIndex}`);
  }
  if(menuIndex == 0){
    let mob_sub_main_menu = menuItem.querySelectorAll('.offcanvas__sub_menu');
    mob_sub_main_menu.forEach((subMenu, mob_subMenuIndex) => {
      subMenu.classList.add(`mob_main_sub_menu-${mob_subMenuIndex}`);
      subMenu.classList.add(`mob_main_custom_menu`);
      let subMenuItems = subMenu.querySelectorAll('li ul .offcanvas__sub_menu_li li');
      subMenuItems.forEach((li, index) => {
        if (index < 4) {
          li.style.display = 'block';
      } else {
          li.style.display = 'none';
      }
      })
    })
  }
  })
})




var elements = document.querySelectorAll('[class*="mob_main_sub_menu-"]');

elements.forEach(function(element, index) {
  
    // Check if the class of the element is not mob_main_sub_menu-0
    if (!element.classList.contains('mob_main_sub_menu-0')) {
        // Check if the length of .offcanvas__sub_menu_li is below 4
        if (element.querySelectorAll('.offcanvas__sub_menu_li').length > 4) {
          var divmob = document.createElement("div");
          divmob.classList.add("mob_menu_toggle-btn_wrapper"); 
            var paragraph = document.createElement("p");
            paragraph.innerText = 'Show More';
            paragraph.classList.add(`mob_sub_menu_toggle-${index}`);
            paragraph.classList.add(`mob_menu_toggle-btn`);
            divmob.appendChild(paragraph);
            element.appendChild(divmob);
        }
    }
    
});

var toggleButtons = document.querySelectorAll('.mob_menu_toggle-btn');
toggleButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
        console.log('Clicked button:', event.target);
        var mob_menu_btn = event.currentTarget.className;
        if(mob_menu_btn.includes('mob_sub_menu_toggle-')){
          var mob_classListArray = mob_menu_btn.split(' ');
          var mob_matchedClass = mob_classListArray.find(function(cls) {
            return cls.startsWith('mob_sub_menu_toggle-');
          });
          if(mob_matchedClass){
            var mob_splittedClass = mob_matchedClass.split('-')[1];
            console.log("mob_splittedClass",mob_splittedClass)
            var mob_get_parent_menu =document.querySelector(".mob_main_sub_menu-"+mob_splittedClass);
            var mob_header__mega_sub_menu_li = mob_get_parent_menu.querySelectorAll("li");
            console.log("Sff",mob_header__mega_sub_menu_li)
            let mobile = document.querySelector(".mob_sub_menu_toggle-" + mob_splittedClass);
            console.log("dfsf",mobile)
            if(mobile.innerText == 'Show Less'){
              mobile.innerText = 'Show More'
              mob_header__mega_sub_menu_li.forEach(function(li, index) {
                if (index < 4) { 
                    li.style.display = 'block';
                } else {
                    li.style.display = 'none'; 
                }
            });
            }else{
              mobile.innerText = 'Show Less'
              var change_innertext = document.querySelector(".mob_sub_menu_toggle-"+mob_splittedClass);
              change_innertext.innerText = 'Show Less';
              mob_header__mega_sub_menu_li.forEach(function(li) {
                li.style.display = 'block';
            });
            }
          }
        }
    });
});

// Preorder function 
const product_swatch = document.querySelectorAll('.product-swatch');

  function handleClick(event) {
    const variantQuantityStr = this.getAttribute('data-variantquantity');
    const cart_name = this.getAttribute('cart-name');
      const NextReleaseDate = this.getAttribute('next-release-date');
     var metafieldTxt = "<strong>Shipping: </strong>" + NextReleaseDate;
    const cart_btn_wrapper = document.querySelector('.product-form__cart--box');
    console.log("cart_btn_wrapper",cart_btn_wrapper)

    const variantQuantity = parseFloat(variantQuantityStr);
        //console.log('Variant Quantity:', variantQuantity);
     var metafield_date = document.querySelector('.metafield-shipping');
          var buttonText = document.querySelector('.button.product-form__submit.button');
          var add_cart_icon = document.getElementById('add-cart-icon');
          const svgElement = add_cart_icon.querySelector('svg');
          const clonedSVG = svgElement.cloneNode(true);

          console.log("svgElement",svgElement)
          setTimeout(function() {
            buttonText.innerHTML = '';
            buttonText.appendChild(clonedSVG);
            const textNode = document.createTextNode(' ' + cart_name);
        buttonText.appendChild(textNode);
            if (NextReleaseDate) {
              debugger
          if(cart_name != 'Add to cart'){   
            metafield_date.style.display='block';  
          metafield_date.innerHTML = metafieldTxt;
          if (cart_btn_wrapper) {
  cart_btn_wrapper.classList.add('set_preorder');
}
          }else{
            metafield_date.style.display='none';  
          }
          }else{
            metafield_date.innerHTML = '';
               if (cart_btn_wrapper) {
  cart_btn_wrapper.classList.remove('set_preorder');
}     
          }
//console.log("changed")        
        }, 800);
        }
        product_swatch.forEach(element => {
    element.addEventListener('click', handleClick);
});

// window.onload = function() {
//   const metafieldElement = document.querySelector('.metafield-shipping');
//   if (metafieldElement && metafieldElement.textContent.trim() !== '') {
//     const cartBtnWrapper = document.querySelector('.product-form__cart--box');
//     if (cartBtnWrapper) {
//       cartBtnWrapper.classList.add('set_preorder');
//     }
//   }
// };

window.onload = function() {
    var check_cart_name = document.querySelector('.product-form__input input[type=radio]:checked + label:not(.variant--swatch-custom)');

    if (check_cart_name) {
        var cartName = check_cart_name.getAttribute('cart-name');
        const cart_btn = document.querySelector('.button.product-form__submit.button');
        var metafield_date = document.querySelector('.metafield-shipping');
        const NextReleaseDate = check_cart_name.getAttribute('next-release-date');
        var metafieldTxt = "<strong>Shipping: </strong>" + NextReleaseDate;
        if (cart_btn) {
          setTimeout(function() {
              cart_btn.innerHTML = '';
          var add_cart_icon = document.getElementById('add-cart-icon');
          const svgElement = add_cart_icon.querySelector('svg');
          const clonedSVG = svgElement.cloneNode(true);
             cart_btn.appendChild(clonedSVG);
          const textNode = document.createTextNode(' ' + cartName);
        cart_btn.appendChild(textNode);
    
        if (NextReleaseDate) {
      if(cartName != 'Add to cart'){   
        metafield_date.style.display='block';  
      metafield_date.innerHTML = metafieldTxt;
      if (cart_btn_wrapper) {
cart_btn_wrapper.classList.add('set_preorder');
}
      }else{
        metafield_date.style.display='none';  
      }
      }else{
        metafield_date.innerHTML = '';
           if (cart_btn_wrapper) {
cart_btn_wrapper.classList.remove('set_preorder');
}     
      }
              }, 800);
        } else {
            console.log('Cart button wrapper not found.');
        }
    }
};


